export { default as FiltersBar } from './filtersBar.container';
